var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicenseDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "license_dark",
    transform: "translate(-252 -778)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11405",
    "data-name": "Rectangle 11405",
    width: 24,
    height: 24,
    transform: "translate(252 778)",
    fill: "#4b4e6d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_system_report",
    d: "M3,2A2,2,0,0,0,1,4V16a2,2,0,0,0,2,2h7v2H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H14V18h7a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2ZM3,4H21V16H3Z",
    transform: "translate(252 778)",
    fill: "#4b4e6d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseDark);
export default __webpack_public_path__ + "static/media/license_dark.33754f2826f25f5a2ae69761221b58e7.svg";
export { ForwardRef as ReactComponent };